/* =========================================================
   PEBE SHOP — INTRO
   RÁPIDA + FLUIDA
========================================================= */

(function () {

  "use strict";

  window.pebeIntroFinished = false;


  function startPeBeIntro() {

    const intro =
      document.getElementById("pebe-intro");

    const loader =
      intro
        ? intro.querySelector(".pebe-intro__loader-bar")
        : null;


    /* =====================================================
       SI NO EXISTE LA INTRO
    ===================================================== */

    if (!intro || !loader) {

      window.pebeIntroFinished = true;

      window.dispatchEvent(
        new Event("pebeIntroFinished")
      );

      return;
    }


    /* =====================================================
       EVITAR DOBLE EJECUCIÓN
    ===================================================== */

    if (
      intro.dataset.started === "true"
    ) {

      return;

    }

    intro.dataset.started = "true";


    /* =====================================================
       BLOQUEAR SCROLL SOLO DURANTE LA INTRO
    ===================================================== */

    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";


    /* =====================================================
       CUANDO TERMINA LA BARRA
    ===================================================== */

    function finishIntro() {

      /* Evitar que se ejecute dos veces */

      if (
        intro.dataset.finished === "true"
      ) {

        return;

      }

      intro.dataset.finished = "true";


      /* =================================================
         INICIAR SALIDA
      ================================================= */

      intro.classList.add(
        "pebe-intro--hidden"
      );


      /* =================================================
         RESTAURAR LA PÁGINA INMEDIATAMENTE
      ================================================= */

      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";


      /* =================================================
         AVISAR QUE TERMINÓ
      ================================================= */

      window.pebeIntroFinished = true;

      window.dispatchEvent(
        new Event("pebeIntroFinished")
      );


      /* =================================================
         ELIMINAR DESPUÉS DE LA ANIMACIÓN
      ================================================= */

      setTimeout(function () {

        if (
          intro &&
          intro.parentNode
        ) {

          intro.parentNode.removeChild(
            intro
          );

        }

      }, 650);

    }


    /* =====================================================
       ESPERAR A QUE TERMINE LA BARRA
    ===================================================== */

    loader.addEventListener(
      "animationend",
      function (event) {

        if (
          event.animationName === "pebeLoader"
        ) {

          finishIntro();

        }

      },
      { once: true }
    );


    /* =====================================================
       RESPALDO
       
       Si el animationend no funciona por algún motivo,
       la intro termina igualmente.
    ===================================================== */

    setTimeout(
  finishIntro,
  2350
);

  }


  /* =======================================================
     INICIAR
  ======================================================= */

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      startPeBeIntro,
      { once: true }
    );

  } else {

    startPeBeIntro();

  }

})();